import React from 'react';
import {Helmet} from 'react-helmet';
import {getCleanTitle, getDefaultTitle, getTitleTemplate, isRootPage, sanitizeHtml} from 'utils';

import {compose} from 'recompose';
import withRouter, {WithRouterProps} from 'hoc/withRouter';

export interface DocumentMetaProps {
    // DO NOT PASS TYPOGRAPHER'S STRING
    title?: string;
    sectionTitle?: string;
}

type DocumentMetaInnerProps = DocumentMetaProps & WithRouterProps;

const DocumentMeta: React.FC<DocumentMetaInnerProps> = (props) => {
    const {router} = props;
    const isRoot = isRootPage(router.pathname);

    const title = sanitizeHtml(props.title);
    const sectionTitle = sanitizeHtml(props.sectionTitle);

    return (
        <Helmet
            title={getCleanTitle(title)}
            defaultTitle={isRoot ? undefined : getDefaultTitle(sectionTitle)}
            titleTemplate={isRoot ? undefined : getTitleTemplate(sectionTitle)}
        />
    );
};

export default compose<DocumentMetaInnerProps, DocumentMetaProps>(withRouter)(DocumentMeta);
